import { TCV, TCV_MARGIN, ACV, ACV_MARGIN, MRR, MRR_MARGIN, ARR, ARR_MARGIN } from 'customer-data-objects/lineItem/PropertyNames';
export const DEAL_AMOUNT_PREFERENCES = {
  hs_tcv: 'hs_tcv',
  hs_acv: 'hs_acv',
  hs_arr: 'hs_arr',
  hs_mrr: 'hs_mrr',
  legacy: 'legacy',
  disabled: 'disabled'
};
export const MARGIN_PROPERTIES = {
  [TCV]: TCV_MARGIN,
  [ACV]: ACV_MARGIN,
  [MRR]: MRR_MARGIN,
  [ARR]: ARR_MARGIN
};